// extracted by mini-css-extract-plugin
export default {"author":"Talk_author__-zDkz","item":"Talk_item__A97Ep","lemon":"Talk_lemon__4mdVk","spanDate":"Talk_spanDate__oLBYp","link":"Talk_link__judtr"};